<button
    mat-stroked-button
    fxLayout="row"
    fxLayoutAlign="center center"
    mat-stroked-button
    class="white-btn py-8 px-12"
    color="white"
    [class.muted-solid-icon]="mutedSolidIcon"
    [class.is-active]="isActive"
    [class.is-rounded]="isRounded"
    [class.w-full]="fullWidth"
    [class.force-trailing-icon-on-right]="forceTrailingIconOnRight"
    (click)="onClickButton($event)"
    [disabled]="disabled"
    [loading]="isLoading"
>
    <mat-icon
        [class.mr-8]="label || showThreeDots || showArrowRight || showArrowDown || counter"
        [class.muted-solid-icon__leading]="mutedSolidIcon"
        *ngIf="icon"
        >{{ icon }}</mat-icon
    >
    <mat-icon
        [class.mr-8]="label || showThreeDots || showArrowRight || showArrowDown || counter"
        [class.muted-solid-icon__leading]="mutedSolidIcon"
        *ngIf="svgIcon"
        [svgIcon]="svgIcon"
    ></mat-icon>

    <span class="text-sm text-nowrap button-label">{{ label | translate: labelTranslateParams }}<span *ngIf="showThreeDots">...</span></span>
    <mat-icon class="ml-8 trailing-arrow-icon" *ngIf="showArrowRight">keyboard_arrow_right</mat-icon>
    <mat-icon class="ml-8 trailing-arrow-icon" *ngIf="showArrowDown">keyboard_arrow_down</mat-icon>
    <span class="text-sm" *ngIf="counter"> &nbsp;({{ counter }})</span>
</button>
